import { REMINDERS_PAUSED_REASONS, resolveRemindersPausedReason } from '@shared/core/billing'
import { USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign, AlertContext } from '../alerts.types'

export const pausedRemindersModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.PAUSED_REMINDERS,
  priority: ALERT_CAMPAIGN_PRIORITIES.PAUSED_REMINDERS,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.PAUSED_REMINDERS],
  isEligible: (context) => isOwedPausedRemindersModal(context) && context.pausedReminders.isReady,
}

// Selecting a campaign marks it seen, so nothing may be selected before the
// paused modal's data loads or a lower-priority prompt takes its slot.
export function isAwaitingPausedRemindersData(context: AlertContext): boolean {
  return isOwedPausedRemindersModal(context) && !context.pausedReminders.isReady
}

function isOwedPausedRemindersModal(context: AlertContext): boolean {
  if (!context.profile || resolveRemindersPausedReason(context.profile) !== REMINDERS_PAUSED_REASONS.quota) {
    return false
  }

  return !context.userEvents.has(USER_EVENTS.PAUSED_REMINDERS_MODAL_SEEN)
}
